/* RESPONSIBLE TEAM: team-standalone */
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import type FinStandaloneService from 'embercom/services/fin-standalone-service';

export default class Workflow extends Route {
  @service declare finStandaloneService: FinStandaloneService;

  async beforeModel() {
    await this.finStandaloneService.platform.loadDataFields();
  }
}
